import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AtwReviewService {
  constructor(private http: HttpClient) {}

  // =========================
  // Reviews
  // =========================

  getReviews(filters: any = {}): Observable<any> {
    let params = new HttpParams();

    Object.keys(filters).forEach((key) => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  getReview(id: any, lang?: 'ar' | 'en'): Observable<any> {
    let params = new HttpParams();

    if (lang) {
      params = params.set('lang', lang);
    }

    return this.http.get(`${environment.Server_URL}/reviews/${id}`, {
      params,
    });
  }

  addReview(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/reviews`, data);
  }

  updateReview(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/reviews/${id}`, data);
  }

  /**
   * Use this when updating with image/FormData.
   * Laravel comment says:
   * POST /api/reviews/{id}
   * _method=PUT
   */
  updateReviewWithFormData(id: any, formData: FormData): Observable<any> {
    formData.append('_method', 'PUT');

    return this.http.post(`${environment.Server_URL}/reviews/${id}`, formData);
  }

  deleteReview(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/reviews/${id}`);
  }

  // =========================
  // Helpers
  // =========================

  getActiveReviews(lang: 'ar' | 'en' = 'en'): Observable<any> {
    const params = new HttpParams()
      .set('status', 'active')
      .set('lang', lang);

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  getFeaturedReviews(lang: 'ar' | 'en' = 'en', perPage: any = 9): Observable<any> {
    const params = new HttpParams()
      .set('featured', '1')
      .set('status', 'active')
      .set('lang', lang)
      .set('per_page', perPage);

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  getReviewsByUserType(
    userType: 'candidate' | 'company' | 'admin' | 'guest',
    lang: 'ar' | 'en' = 'en',
    perPage: any = 9
  ): Observable<any> {
    const params = new HttpParams()
      .set('user_type', userType)
      .set('status', 'active')
      .set('lang', lang)
      .set('per_page', perPage);

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  getReviewsByStatus(status: 'active' | 'inactive' | 'pending', page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  searchReviews(keyword: string, page: any = 1, lang: 'ar' | 'en' = 'en'): Observable<any> {
    const params = new HttpParams()
      .set('q', keyword)
      .set('page', page)
      .set('lang', lang);

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  getPaginatedReviews(page: any = 1, perPage: any = 9, filters: any = {}): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    Object.keys(filters).forEach((key) => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get(`${environment.Server_URL}/reviews`, { params });
  }

  // =========================
  // FormData Builder
  // =========================

  buildReviewFormData(data: any): FormData {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      const value = data[key];

      if (value !== null && value !== undefined && value !== '') {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'boolean') {
          formData.append(key, value ? '1' : '0');
        } else {
          formData.append(key, value);
        }
      }
    });

    return formData;
  }
}